import { readJsonOrStatus } from './json-or-status.js';

// The login endpoint answers its own rejections (401 "invalid token", a wrong password) with a
// JSON { statusCode, message } body the form shows as-is; an error page in front of it is named
// by its status, "Login failed: 520", the way silent login does (Rollbar #715, #498, #2584).
export const readLoginResponse = readJsonOrStatus('Login');
